import { NavLink, useLocation } from 'react-router-dom';
import { haptics } from '../telegram';
import { HomeIcon, ChartIcon, CalendarIcon, UserIcon } from './icons';

const tabs = [
  { to: '/', label: 'Главная', Icon: HomeIcon },
  { to: '/leaderboard', label: 'Рейтинг', Icon: ChartIcon },
  { to: '/schedule', label: 'Турниры', Icon: CalendarIcon },
  { to: '/profile', label: 'Профиль', Icon: UserIcon },
];

export function TabBar() {
  // Свои достижения живут под профилем (K1: таб-бар с активным «Профилем»).
  const inAchievements = useLocation().pathname.startsWith('/achievements');
  return (
    <nav className="tabbar">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          onClick={() => haptics.tap()}
          className={({ isActive }) =>
            isActive || (to === '/profile' && inAchievements) ? 'active' : ''
          }
        >
          <span className="ico">
            <Icon />
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
